import { render, staticRenderFns } from "./card-recap.vue?vue&type=template&id=474049ae&"
import script from "./card-recap.vue?vue&type=script&lang=js&"
export * from "./card-recap.vue?vue&type=script&lang=js&"
import style0 from "./card-recap.vue?vue&type=style&index=0&id=474049ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports